import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * 条件类名拼接 + Tailwind 冲突消解。
 *
 * AGENTS.md 9 要求优先用现成依赖，这里就是 `clsx` + `tailwind-merge` 的标准组合：
 *   - `clsx` 负责把条件、数组、对象拉平成类名串；
 *   - `tailwind-merge` 负责让**后写的赢**。这一点很关键：组件内部先写
 *     `px-4`，调用方通过 `className` 传 `px-6`，纯拼接的结果取决于 Tailwind
 *     生成 CSS 的顺序（往往是内部那条赢），而 `twMerge` 会把 `px-4` 直接删掉。
 *     没有它，所有「允许外部覆盖样式」的组件都是不可靠的。
 */
export function cn(...values: ClassValue[]): string {
  return twMerge(clsx(values))
}
